// extracted by mini-css-extract-plugin
export default {"isInvisible":"_63c8e5af"};